import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Message } from 'src/app/api/message'; import { ConfirmationService } from 'primeng/api'; import { BadgeCountService } from 'src/app/services/badge-count.service';
import { User } from 'src/app/api/user'; import { Subscription } from 'rxjs'; import { MessageService } from 'primeng/api';
import { SwiperModule } from 'swiper/angular'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ChatWebSocketService } from 'src/app/services/chat-web-socket.service';
import { ChatApiService } from 'src/app/services/chat-api.service';
import { Output, EventEmitter } from '@angular/core'; import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar'; import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar'; import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';  import { BadgeModule } from 'primeng/badge';
import { TimeagoModule } from 'ngx-timeago';
import { SkeletonModule } from 'primeng/skeleton'; import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { SsTimeagoPipe } from 'src/app/pipes/ss-timeago.pipe';
@Component({
    selector: 'app-chat-box',
    templateUrl: './chat-box.component.html',
    standalone: true,
    styles: [`
            .pinned-messages-container {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                z-index: 10;
                padding: 10px 0;
                backdrop-filter: blur(10px);
                display: flex;
                align-items: center;
                justify-content: flex-start; /* 🔥 Agora os alertas ficam alinhados à esquerda */
                overflow-x: auto;
            }

            /* 🔹 Estilo dos alertas fixos */
            .alert-card {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                justify-content: flex-start;
                padding: 0.5rem 1rem;
                border-radius: 50px;
                font-weight: bold;
                background: rgba(0, 0, 0, 0.2);
                backdrop-filter: blur(10px);
                transition: transform 0.2s ease-in-out;
                white-space: nowrap;
                cursor: pointer;
                width: 12rem; 
                    padding: 0;
                min-height: 2rem;
                border: 1px solid #333333;
            }

            .alert-card:hover {
                transform: scale(1.05);
            }

            /* 🔹 Ícone do Alerta */
            .alert-icon-container {
                display: flex;
                align-items: center;
                background-color: red !important;
                justify-content: center;
                width: 3rem;
                
                height: 2rem;
                border-radius: 50%;
                overflow: hidden;
                background-color: rgba(255, 255, 255, 0.3);
            }

            .alert-icon {
                font-size: 1.2rem;
                color: white;
            }

            /* 🔹 Texto do Alerta */
            .alert-label {
                font-size: 0.85rem;
                font-weight: bold;
                color: white;
                width: 100%;
            }

            /* 🔹 Ajusta o swiper para os alertas */
            :host ::ng-deep .mySwiperAlerts .swiper-slide {
                width: 12rem !important; /* 🔥 Todos os alertas agora têm a mesma largura */
                display: flex;
                justify-content: flex-start;
                padding: 0;
            }

            .chat-messages {
                overflow-y: auto;
                padding-top: 60px; /* 🔥 Agora deixa espaço suficiente para os alertas */
            }

            :host ::ng-deep .mySwiperAlerts{
                margin-left: 0rem;
            }

            :host ::ng-deep .ss-g-link-responder, .ss-g-link-remover {
                font-size: 0.95rem;
                opacity: 0.9;
            }

            .ss-verified-badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
                border-radius: 9999px;
                background: #1d9bf0;
                color: #ffffff;
                flex: 0 0 auto;
            }

            .ss-verified-badge .pi {
                font-size: 0.65rem;
                line-height: 1;
            }

            .ss-g-emojis {
                font-family: "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Noto Emoji","Segoe UI Symbol",sans-serif !important;
                font-variant-emoji: emoji;
                line-height: 1;
            }

            /* Mobile já tem emoji nativo no teclado — some o botão só nessa faixa */
            @media (max-width: 768px) {
                .ss-g-emojis {
                    display: none !important;
                }
            }

            .ss-chat-actions-right {
                justify-content: flex-end !important;
                max-width: 80%;
                margin-left: auto;
            }
            .highlight-reply {
                animation: highlightReply 1s;
                background: var(--yellow-600);
                border-radius: 5px;
            }
            @keyframes highlightReply {
                from { background: var(--yellow-600); }
                80%  { background: var(--yellow-600); }
                to   { background: transparent; }
            }

            .ss-g-link-responder:hover,
            .ss-g-link-remover:hover {
                text-decoration: none !important;
            }
            :host ::ng-deep .ss-chat-avatar .p-avatar-text {
                font-weight: 700;
            }
            

    `],
    imports: [
        CommonModule,
        ProgressBarModule,
        FormsModule,
        ToastModule,
        AvatarModule,
        InputTextModule,
        ButtonModule,
        BadgeModule,
        SwiperModule,
        SkeletonModule,
        OverlayPanelModule,
        RippleModule,
        TooltipModule,
        SsTimeagoPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatBoxComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() showTopChat: boolean = true;
    @Input() chatId: string = '';
    @Input() storeId: string = '';
    defaultUserId: number = 123;
    @ViewChild('chatWindow', { static: false }) private chatContainer?: ElementRef<HTMLDivElement>;

    @Input() pinnedMessages: any[] = [];

    private msgSub?: Subscription;

    @Input() disableSendInput: boolean = false;

    message!: Message;
    textContent: string = '';


    uploadedFiles: any[] = [];

    emojis = [
        '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜', '😝', '😛',
        '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐', '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡', '🤬', '😔',
        '😟', '😠', '😡', '🤬', '😔', '😕', '🙁', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤'
    ];

    @Input() user!: User;
    commentsNaoLidos: number = 0;

    private apiSub?: Subscription;

    constructor(
        private chatWebSocketService: ChatWebSocketService, private badgeCountService: BadgeCountService,
        private confirmationService: ConfirmationService, private messageService: MessageService, private errorHandler: ErrorHandlerService,
        private cdr: ChangeDetectorRef, private chatApiService: ChatApiService) {
        this.scrollToBottom();
        this.badgeCountService.getUnreadCommentsCountObservable().subscribe(count => {
            this.commentsNaoLidos = count;
        });
    }

    ngAfterViewInit() {
        this.scrollToBottom();
    }

    scrollToBottom(): void {
        setTimeout(() => {
            if (this.chatContainer) {
                this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
            }
        }, 100);
    }

    setMessage() {
        if (this.user) {
            let filteredMessages = this.user.messages.filter(m => m.ownerId !== this.defaultUserId);
            this.message = filteredMessages[filteredMessages.length - 1];
        }
    }

    getAvatarLabel(message: any) {
        const isAdmin = message?.is_admin === true || message?.is_admin === 1;
        const rawName = String(message?.from || message?.from_name || '').trim();

        // Admin sem nome vindo do backend -> "AD"
        if (isAdmin && !rawName) return 'AD';

        const name = (rawName || '??').split(' ').filter(Boolean);
        if (name.length === 1) return name[0].slice(0, 1).toUpperCase();
        return (name[0][0] + name[name.length - 1][0]).toUpperCase();
    }

    getDisplayName(message: any): string {
        const rawName = String(message?.from || message?.from_name || '').trim();
        if (rawName) return rawName;

        const isAdmin = message?.is_admin === true || message?.is_admin === 1;
        if (isAdmin) {
            return message?.isOwnMessage ? 'Você' : 'Loja';
        }
        return message?.isOwnMessage ? 'Você' : 'Usuário';
    }

    getBubbleClass(message: any): string {
        const isAdmin = message?.is_admin === true || message?.is_admin === 1;
        return isAdmin ? 'bg-primary-50 text-primary-900' : 'bg-primary-100 text-primary-900';
    }

    @Input() isLoadingMessages: boolean = false;
    //////////////////////// isOwnMessage
    private normalizeMessage(raw: any) {
        // preserve created_at se já vier com Z/offset
        let created = raw?.created_at || raw?.time || new Date().toISOString();

        if (typeof created === 'string') {
            created = created.trim();

            // "YYYY-MM-DD HH:mm:ss(.ffffff)" -> "YYYY-MM-DDTHH:mm:ss(.ffffff)"
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/.test(created)) {
                created = created.replace(' ', 'T');
            }

            // Trunca microssegundos para milissegundos (Date não garante parse com 6 dígitos)
            created = created.replace(/\.(\d{3})\d+(?=([Zz]|[+\-]\d{2}:?\d{2})?$)/, '.$1');

            // Se não tiver TZ explícito, assume UTC (evita "3 hours from now")
            if (!/[Zz]|[+\-]\d{2}:?\d{2}$/.test(created)) {
                created = `${created}Z`;
            }
        }

        let createdDate = new Date(created);
        // Se por algum motivo vier "no futuro" (bug comum de timezone +3h), corrige para não exibir "from now"
        if (!isNaN(createdDate.getTime()) && createdDate.getTime() - Date.now() > 60_000) {
            createdDate = new Date(createdDate.getTime() - 3 * 60 * 60 * 1000);
        }
        const created_at = isNaN(createdDate.getTime()) ? new Date().toISOString() : createdDate.toISOString();

        const ip = String(raw?.ip ?? raw?.user_chat_id ?? raw?.from_id ?? '');

        return {
            ...raw,
            ip,
            created_at,                       // usado no template
            text: raw?.text ?? raw?.content ?? '',
            from: raw?.from ?? raw?.from_name ?? ''
        };
    }

    threads: Array<{ root: any; replies: any[] }> = [];

    private buildThreads(list: any[]): Array<{ root: any; replies: any[] }> {
        const byId = new Map<string, any>();
        for (const m of list) {
            if (m?.id != null) byId.set(String(m.id), m);
        }

        const rootIds = new Set<string>();
        const repliesByRoot = new Map<string, any[]>();

        const findRootId = (msg: any): string | null => {
            let cur = msg;
            const visited = new Set<string>();

            while (cur?.reply_to_id != null) {
                const nextId = String(cur.reply_to_id);
                if (visited.has(nextId)) break;
                visited.add(nextId);

                const parent = byId.get(nextId);
                if (!parent) return nextId;
                cur = parent;
            }

            return cur?.id != null ? String(cur.id) : null;
        };

        for (const m of list) {
            const id = m?.id != null ? String(m.id) : '';
            const replyTo = m?.reply_to_id != null ? String(m.reply_to_id) : '';

            if (!replyTo) {
                if (id) rootIds.add(id);
                continue;
            }

            const rootId = findRootId(m);
            if (!rootId) continue;

            // Se o root não está carregado, renderiza a mensagem como "root" para não sumir da lista
            if (!byId.has(rootId)) {
                if (id) rootIds.add(id);
                continue;
            }

            if (rootId === id) {
                rootIds.add(id);
                continue;
            }

            const arr = repliesByRoot.get(rootId) ?? [];
            arr.push(m);
            repliesByRoot.set(rootId, arr);
        }

        const roots = list.filter(m => m?.id != null && rootIds.has(String(m.id)));

        return roots.map(root => {
            const rid = String(root.id);
            const replies = (repliesByRoot.get(rid) ?? [])
                .slice()
                .sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));
            return { root, replies };
        });
    }

	    @Input() set messages(val: any[]) {
	        const localUserIp = localStorage.getItem('user_chat') || '';
	        const cleaned = (val || []).filter(m => !(m?.is_deleted === true || m?.is_deleted === 1));
	        this._messages = cleaned
	            .map(raw => {
	                const m = this.normalizeMessage(raw);
	                const isOwn = this.isAdmin ? (m.is_admin === true || m.is_admin === 1)
	                    : (m.ip === localUserIp);
	                return { ...m, isOwnMessage: isOwn, time: m.created_at };
            })
            .sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)); // ✅ ordena pelo ISO 
        this.threads = this.buildThreads(this._messages);
        this.scrollToBottom();
        this.cdr.markForCheck();
    }


    private _messages: any[] = [];
    get messages() { return this._messages; }

    // Auxiliar para converter string ou Date para HH:mm
    private formatDate(date: string | Date): string {
        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return '';
        return d.toTimeString().slice(0, 5); // HH:mm
    }
    getReplyText(message: any): string {
        if (!message.reply_to_id) return '';
        // Primeiro tenta pegar snapshot se já veio do backend:
        if (message.reply_to_text) return message.reply_to_text;
        // Senão procura na lista local:
        const replied = this.messages.find(m => m.id == message.reply_to_id);
        return replied ? (replied.text || replied.content) : '[mensagem não encontrada]';
    }
    scrollToMessage(replyToId: number | string) {
        const el = document.getElementById('msg-' + replyToId);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Opcional: realce visual
            el.classList.add('highlight-reply');
            setTimeout(() => el.classList.remove('highlight-reply'), 1500);
        }
    }
    ////////////////////////
    @Input() isAdmin: boolean = false;
    //@Input() messages: any[] = [];
    ngOnInit(): void {
        if (!this.isAdmin) {
            this.setMessage();
            if (this.storeId) {
                // Quando usa API, o load é delegado ao onChatSidebarShow do pai
                // para evitar chamadas duplicadas (ngOnInit + onChatSidebarShow)
                return;
            }
            this.subscribeToMessages();
            this.loadMessages();
        }
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        const chatChanged = changes['chatId'] && !changes['chatId'].firstChange;
        const storeChanged = changes['storeId'] && !changes['storeId'].firstChange;

        if ((chatChanged || storeChanged) && !this.isAdmin) {
            this.msgSub?.unsubscribe();
            this.apiSub?.unsubscribe();
            this.messages = [];

            if (this.storeId) {
                this.loadMessages();
                this.cdr.markForCheck();
                return;
            }

            try {
                await this.chatWebSocketService.connectSocket(this.chatId);
                this.loadMessages();
                this.subscribeToMessages();
                this.cdr.markForCheck();
            } catch (err) {
                this.isLoadingMessages = false;
                this.isLoadingChange.emit(false);
                this.errorHandler.handleSocket();
                console.error('[Chat] Erro ao conectar socket:', err);
            }
        }
    }
    ngOnDestroy(): void {
        this.msgSub?.unsubscribe();
        this.apiSub?.unsubscribe();
    }
    @Output() isLoadingChange = new EventEmitter<boolean>();
    @Output() messageCreated = new EventEmitter<any>();
    @Output() messageRemoved = new EventEmitter<{ id: any; chatId: string }>();
    async loadMessages() {
        if (!this.chatId) {
            this.isLoadingMessages = false;
            this.isLoadingChange.emit(false);
            return;
        }

        if (this.storeId) {
            if (this.isLoadingMessages) {
                return;
            }

            this.isLoadingMessages = true;
            this.isLoadingChange.emit(true);
            this.messages = [];

            this.apiSub?.unsubscribe();
            this.apiSub = this.chatApiService.getMessages(this.storeId, this.chatId).subscribe({
                next: (messages) => {
                    const localUserIp = localStorage.getItem('user_chat') || '';
                    this.messages = (messages || []).map(msg => {
                        const m = this.normalizeMessage({ ...msg, ip: msg.ip ?? localUserIp });
                        return { ...m, isOwnMessage: m.ip === localUserIp };
                    });
                    this.isLoadingMessages = false;
                    this.isLoadingChange.emit(false);
                    this.cdr.markForCheck();
                    this.scrollToBottom();
                },
                error: (err) => {
                    this.isLoadingMessages = false;
                    this.isLoadingChange.emit(false);
                    this.errorHandler.handle(err, 'Falha ao carregar mensagens.');
                    this.cdr.markForCheck();
                }
            });
            return;
        }

        // Fallback socket (outros contextos que não usam storeId)
        this.isLoadingMessages = true;
        this.isLoadingChange.emit(true);
        this.messages = [];

        try {
            await this.chatWebSocketService.connectSocket(this.chatId);
        } catch (err) {
            this.isLoadingMessages = false;
            this.isLoadingChange.emit(false);
            this.cdr.markForCheck();
            return;
        }

        this.chatWebSocketService.getInitialMessages(this.chatId, { refresh: true }).subscribe(messages => {
            const localUserIp = localStorage.getItem('user_chat') || '';
            this.messages = (messages || []).map(msg => {
                const m = this.normalizeMessage({ ...msg, ip: msg.ip ?? msg.from_id ?? localUserIp });
                const isOwn = this.isAdmin
                    ? (m.is_admin === true || m.is_admin === 1)
                    : (m.ip === localUserIp);
                return { ...m, isOwnMessage: isOwn };
            });
            this.isLoadingMessages = false;
            this.isLoadingChange.emit(false);
            this.cdr.markForCheck();
            this.scrollToBottom();
        });
    }


    fetchInitialMessages() {
        this.chatWebSocketService.getInitialMessages(this.chatId).subscribe(messages => {
            const localUserIp = localStorage.getItem('user_ip');

            this.messages = messages.map(message => {
                const isOwnMessage = message.ip === localUserIp;
                return {
                    ...message,
                    isOwnMessage: isOwnMessage
                };
            });

            this.cdr.markForCheck();  // Necessário para atualizar a view com ChangeDetectionStrategy.OnPush
            this.scrollToBottom();
        });
    }

    subscribeToMessages() {
        this.chatWebSocketService.receiveMessages().subscribe(message => {
            if (message.chatId !== this.chatId) return;
            const localUserIp = localStorage.getItem('user_chat');

            const formattedMessage = {
                from: message.username,
                text: message.text,
                time: message.time,
                ip: message.ip, // 🔹 Adiciona o IP na mensagem para debug
                isOwnMessage: message.ip === localUserIp // 🔹 Verifica corretamente se é a mensagem do próprio usuário
            };


            // 🔹 Evita duplicação: se a mensagem já existe na lista, não adiciona
            if (!this.messages.some(m => m.text === message.text && m.ip === message.ip)) {
                this.messages = [...this.messages, formattedMessage];
                this.cdr.markForCheck();
                this.scrollToBottom();
            }
        });
    }

    sendMessage() {
        if (!this.textContent.trim()) return;
        if (this.isAdmin && this.replyingToMessage) {
            const replyToId = this.replyingToMessage.id;
            const content = this.textContent.trim();
            const roomUniqId = this.replyingToMessage.room_uniq_id || this.chatId;

            console.log(this.replyingToMessage)

            // Verifica se a mensagem era não lida
            const eraNaoLida = !this.replyingToMessage.is_read || this.replyingToMessage.is_read === 0;

            this.chatWebSocketService.answerChat(replyToId, content, roomUniqId, this.replyingToMessage.user_chat_id).subscribe({
                next: (res) => {
                    const rawReply = res?.reply ?? null;

                    // Se o backend não retornar o objeto da reply, cria um fallback local (UI não fica “parada”).
                    const replyMessage = rawReply ? {
                        ...rawReply,
                        // padroniza campos usados no front
                        id: rawReply.id ?? `tmp-${Date.now()}-${Math.random().toString(16).slice(2)}`,
                        reply_to_id: rawReply.reply_to_id ?? replyToId,
                        room_uniq_id: rawReply.room_uniq_id ?? roomUniqId,
                        created_at: rawReply.created_at ?? new Date().toISOString(),
                        is_admin: rawReply.is_admin ?? 1,
                        from: rawReply.from_name ?? rawReply.from ?? 'Loja',
                        from_name: rawReply.from_name ?? rawReply.from ?? 'Loja',
                        content: rawReply.content ?? content,
                        text: rawReply.text ?? rawReply.content ?? content,
                        live_uniq_id: this.chatId
                    } : {
                        id: `tmp-${Date.now()}-${Math.random().toString(16).slice(2)}`,
                        reply_to_id: replyToId,
                        room_uniq_id: roomUniqId,
                        created_at: new Date().toISOString(),
                        is_admin: 1,
                        from: 'Loja',
                        from_name: 'Loja',
                        content,
                        text: content,
                        live_uniq_id: this.chatId
                    };

                    // Atualiza a UI local (threads) imediatamente
                    this.messages = [...this.messages, replyMessage];
                    this.chatWebSocketService.addMessageToChat(this.chatId, replyMessage);
                    this.messageCreated.emit(replyMessage);
                    this.scrollToBottom();

                    // Em contexto não-admin (storefront) sem rawReply, força reload para pegar id real
                    if (!rawReply && !this.isAdmin) {
                        this.loadMessages();
                    }
                    this.replyingToMessage = null;
                    this.textContent = '';
                    this.cdr.markForCheck();

                    // 🔽 Atualiza o contador de não lidas (chat + badge externa)
                    if (eraNaoLida) {
                        const novoValor = Math.max(0, this.commentsNaoLidos - 1);
                        this.badgeCountService.setUnreadCommentsCount(novoValor);
                        console.log('setando mensagens badge em chat box 1', novoValor)

                    }
                },
                error: (err) => {
                    // Não limpa o texto para permitir retry, mas deixa explícito o erro para o admin.
                    const msg =
                        err?.error?.message ||
                        err?.message ||
                        'Erro ao enviar resposta. Verifique o backend.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Falha ao responder',
                        detail: msg,
                        life: 4000
                    });
                    this.cdr.markForCheck();
                }
            });
        }
        else {
            if (this.isAdmin) {
                const content = this.textContent.trim();
                this.chatWebSocketService.sendAdminMessage(content, this.chatId).subscribe({
                    next: (res) => {
                        const rawMsg = res?.admin_message ?? null;
                        const newMessage = rawMsg ? {
                            ...rawMsg,
                            is_admin: 1,
                            from: rawMsg.from_name ?? 'Loja',
                            from_name: rawMsg.from_name ?? 'Loja',
                            content: rawMsg.content ?? content,
                            text: rawMsg.content ?? content,
                            live_uniq_id: this.chatId,
                            isOwnMessage: true
                        } : {
                            id: `tmp-${Date.now()}-${Math.random().toString(16).slice(2)}`,
                            is_admin: 1,
                            from: 'Loja',
                            from_name: 'Loja',
                            content,
                            text: content,
                            created_at: new Date().toISOString(),
                            live_uniq_id: this.chatId,
                            isOwnMessage: true
                        };
                        this.messages = [...this.messages, newMessage];
                        this.textContent = '';
                        this.scrollToBottom();
                        this.messageCreated.emit(newMessage);
                        this.cdr.markForCheck();
                    },
                    error: (err) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Falha ao enviar',
                            detail: err?.error?.message || 'Erro ao enviar mensagem.',
                            life: 4000
                        });
                        this.cdr.markForCheck();
                    }
                });
                return;
            }
            if (this.textContent.trim()) {
                const user_chat = this.chatApiService.ensureUserChat();
                const rawUserName = localStorage.getItem('user_name');
                const storedName = rawUserName ? rawUserName.replace(/^"|"$/g, '') : '';
                const user_name = storedName || 'Usuário';

                const tempId = `tmp-${Date.now()}-${Math.random().toString(16).slice(2)}`;
                const newMessage = {
                    id: tempId,
                    from: user_name,
                    from_name: user_name,
                    text: this.textContent.trim(),
                    content: this.textContent.trim(),
                    created_at: new Date().toISOString(),
                    ip: user_chat,
                    is_admin: false,
                    isOwnMessage: true
                };

                this.messages = [...this.messages, newMessage]
                    .sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                const contentToSend = this.textContent.trim();
                this.textContent = '';
                this.scrollToBottom();
                this.cdr.markForCheck();

                if (this.storeId) {
                    this.chatApiService.sendMessage(this.storeId, this.chatId, {
                        content: contentToSend,
                        username: user_name,
                        user_chat
                    }).subscribe({
                        next: () => {},
                        error: (err) => {
                            this.errorHandler.handle(err, 'Falha ao enviar mensagem.');
                        }
                    });
                } else {
                    const is_admin = !!this.isAdmin;
                    const userIdRaw = localStorage.getItem('user_id');
                    const user_id_num = is_admin && userIdRaw ? Number(userIdRaw) : undefined;
                    const user_id = (user_id_num && Number.isFinite(user_id_num) && user_id_num > 0) ? user_id_num : undefined;

                    this.chatWebSocketService.sendMessage(this.chatId, contentToSend, user_chat, {
                        isAdmin: is_admin,
                        userId: user_id,
                        username: user_name
                    });
                    this.chatWebSocketService.addMessageToChat(this.chatId, newMessage);
                }
            }
        }
    }




    onEmojiSelect(emoji: string) {
        this.textContent += emoji;
    }

    parseDate(timestamp: number) {
        return new Date(timestamp).toTimeString().split(':').slice(0, 2).join(':');
    }


    onRemoveMessage(message: any) {
        console.log('remover')
        const eraNaoLida = !message.is_read || message.is_read === 0;
        this.confirmationService.confirm({
            message: 'Você realmente deseja remover esta mensagem?',
            header: 'Confirmação de Exclusão',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Remover',
            rejectLabel: 'Cancelar',
            accept: () => {
                this.chatWebSocketService.removeMessage(message.id).subscribe({
                    next: (res) => {
                        this.messages = this.messages.filter(m => m.id !== message.id);
                        this.chatWebSocketService.removeMessageFromChat(this.chatId, message.id);
                        this.messageRemoved.emit({ id: message.id, chatId: this.chatId });
                        this.cdr.markForCheck();
                        this.messageService.add({ severity: 'success', summary: 'Mensagem removida!', life: 2000 });
                        if (eraNaoLida) {
                            const novoValor = Math.max(0, this.commentsNaoLidos - 1);
                            this.badgeCountService.setUnreadCommentsCount(novoValor);
                            console.log('setando mensagens badge em chat box 2', novoValor)
                        }
                    },
                    error: (err) => {
                        this.messageService.add({ severity: 'error', summary: 'Erro ao remover mensagem!', detail: err?.error?.message || '', life: 3000 });
                    }
                });
            },
            reject: () => {
                // Usuário cancelou, não faz nada
            }
        });
    }



    replyingToMessage: any = null;

    onReplyMessage(message: any) {
        this.replyingToMessage = message;
        this.cdr.markForCheck();
    }

    cancelReply() {
        this.replyingToMessage = null;
        this.cdr.markForCheck();
    }
}
